(function () {
  const N8N_URL = 'https://admin.rightgifting.com/webhook/rg-chatbot-v4/chat';
  const SESSION_ID = 'rg_' + Date.now() + '_' + Math.random().toString(36).substr(2, 6);
  const AVATAR_URL = 'https://cdn.shopify.com/s/files/1/0965/1476/9192/files/alisha-pic_1.png?v=1774352592';

  const CHIPS = [
    { emoji: '🎂', text: 'Birthday gift for my best friend' },
    { emoji: '💍', text: 'Anniversary gift for my wife' },
    { emoji: '👩', text: 'Something special for my mom' },
    { emoji: '🎓', text: 'Graduation gift under ₹500' },
  ];

  const TYPING_WORDS = [
    'Unwrapping…',
    'Curating…',
    'Scouting…',
    'Sprinkling…',
    'Matchmaking…',
    'Conjuring…',
    'Handpicking…',
    'Dreaming…',
    'Hunting…',
    'Gifting…',
    'Imagining…',
    'Vibing…',
    'Pondering…',
    'Sparkling…',
    'Obsessing…',
  ];

  document.body.insertAdjacentHTML('beforeend', `
    <button id="rg-chat-bubble" aria-label="Chat with Alisha">
      <img id="rg-bubble-avatar" src="${AVATAR_URL}" alt="Alisha" />
      <div id="rg-bubble-tooltip">Confused what to gift? Alisha can help 🎁</div>
    </button>
    <div id="rg-chat-box" role="dialog" aria-label="Alisha Gift Assistant">
      <div id="rg-chat-header">
        <img id="rg-header-avatar" src="${AVATAR_URL}" alt="Alisha" />
        <div id="rg-header-info">
          <div id="rg-header-name">Alisha</div>
          <div id="rg-header-sub">Gift Guide · Online</div>
        </div>
        <button id="rg-chat-close" aria-label="Close">✕</button>
      </div>
      <div id="rg-chat-messages"></div>
      <div id="rg-chat-input-row">
        <input id="rg-chat-input" type="text" placeholder="Ask Alisha for gift ideas…" autocomplete="off" />
        <button id="rg-chat-send" aria-label="Send">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round">
            <line x1="22" y1="2" x2="11" y2="13"/>
            <polygon points="22 2 15 22 11 13 2 9 22 2"/>
          </svg>
        </button>
      </div>
      <div id="rg-powered">Powered by RightGifting AI</div>
    </div>
  `);

  const bubble    = document.getElementById('rg-chat-bubble');
  const tooltip   = document.getElementById('rg-bubble-tooltip');
  const box       = document.getElementById('rg-chat-box');
  const closeBtn  = document.getElementById('rg-chat-close');
  const messages  = document.getElementById('rg-chat-messages');
  const input     = document.getElementById('rg-chat-input');
  const sendBtn   = document.getElementById('rg-chat-send');
  let lastSender  = null;
  let welcomeShown = false;

  setTimeout(() => {
    tooltip.classList.add('rg-show');
    setTimeout(() => tooltip.classList.remove('rg-show'), 5500);
  }, 3200);

  bubble.addEventListener('click', () => {
    const isOpen = box.style.display === 'flex';
    box.style.display = isOpen ? 'none' : 'flex';
    tooltip.classList.remove('rg-show');
    if (!isOpen && !welcomeShown) showWelcome();
    if (!isOpen) setTimeout(() => input.focus(), 200);
  });

  closeBtn.addEventListener('click', () => box.style.display = 'none');
  sendBtn.addEventListener('click', sendMessage);
  input.addEventListener('keydown', e => {
    if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); sendMessage(); }
  });

  function showWelcome() {
    welcomeShown = true;
    const welcome = document.createElement('div');
    welcome.id = 'rg-welcome';
    welcome.innerHTML = `
      <img id="rg-welcome-avatar" src="${AVATAR_URL}" alt="Alisha" />
      <div id="rg-welcome-name">Hi, I'm Alisha 👋</div>
      <div id="rg-welcome-tagline">Your personal gift guide. Tell me who you're shopping for and I'll find something they'll love.</div>
      <div id="rg-welcome-chips">
        ${CHIPS.map(c => `<div class="rg-chip" data-msg="${c.text}">${c.emoji} ${c.text}</div>`).join('')}
      </div>`;
    messages.appendChild(welcome);
    welcome.querySelectorAll('.rg-chip').forEach(chip => {
      chip.addEventListener('click', () => {
        const msg = chip.getAttribute('data-msg');
        welcome.remove();
        addDateChip();
        triggerSend(msg);
      });
    });
  }

  function addDateChip() {
    const chip = document.createElement('div');
    chip.className = 'rg-date-chip';
    chip.textContent = new Date().toLocaleDateString('en-IN', {
      weekday: 'long', day: 'numeric', month: 'short'
    });
    messages.appendChild(chip);
    lastSender = null;
  }

  function addUserMessage(text) {
    const row = document.createElement('div');
    row.className = 'rg-msg-row user';
    const spacer = document.createElement('div');
    spacer.className = 'rg-tail-spacer';
    const bbl = document.createElement('div');
    bbl.className = 'rg-msg user';
    bbl.textContent = text;
    row.appendChild(spacer);
    row.appendChild(bbl);
    messages.appendChild(row);
    lastSender = 'user';
    scroll();
  }

  function addBotMessage(text, products) {
    if (text) {
      const row = document.createElement('div');
      row.className = 'rg-msg-row bot';
      const av = document.createElement('img');
      av.src = AVATAR_URL;
      av.className = 'rg-row-avatar';
      if (lastSender !== 'bot') av.classList.add('rg-visible');
      const bbl = document.createElement('div');
      bbl.className = 'rg-msg bot';
      bbl.textContent = text;
      row.appendChild(av);
      row.appendChild(bbl);
      messages.appendChild(row);
      lastSender = 'bot';
    }

    if (products && products.length > 0) {
      const wrapper = document.createElement('div');
      wrapper.className = 'rg-carousel-wrapper';
      const label = document.createElement('div');
      label.className = 'rg-carousel-label';
      label.textContent = products.length + ' Gift Ideas for You';
      const carousel = document.createElement('div');
      carousel.className = 'rg-carousel';

      products.forEach(p => {
        const url = p.productUrl || p.product_url || '#';
        const img = p.imageUrl || p.image_url || '';
        const a = document.createElement('a');
        a.className = 'rg-product-card';
        a.href = url;
        a.target = '_blank';
        a.rel = 'noopener';
        a.innerHTML =
          '<div class="rg-card-img-wrap">' +
            '<img src="' + img + '" alt="' + p.name + '" loading="lazy" />' +
            '<div class="rg-card-arrow">↗</div>' +
            '<div class="rg-p-price-overlay">' + p.price + '</div>' +
          '</div>' +
          '<div class="rg-p-info">' +
            '<div class="rg-p-name">' + p.name + '</div>' +
          '</div>';
        carousel.appendChild(a);
      });

      wrapper.appendChild(label);
      wrapper.appendChild(carousel);
      messages.appendChild(wrapper);
      lastSender = 'bot';
    }
    scroll();
  }

  function showTyping() {
    const row = document.createElement('div');
    row.className = 'rg-typing-row';
    row.id = 'rg-typing-row';
    const av = document.createElement('img');
    av.src = AVATAR_URL;
    av.className = 'rg-row-avatar rg-visible';
    const bbl = document.createElement('div');
    bbl.className = 'rg-typing-bubble';
    const wordEl = document.createElement('div');
    wordEl.className = 'rg-typing-word';
    wordEl.textContent = TYPING_WORDS[0];
    const dots = document.createElement('div');
    dots.className = 'rg-typing-dots';
    dots.innerHTML = '<span></span><span></span><span></span>';
    bbl.appendChild(wordEl);
    bbl.appendChild(dots);
    row.appendChild(av);
    row.appendChild(bbl);
    messages.appendChild(row);
    scroll();

    let idx = 1;
    const interval = setInterval(() => {
      wordEl.classList.add('rg-fade');
      setTimeout(() => {
        wordEl.textContent = TYPING_WORDS[idx % TYPING_WORDS.length];
        wordEl.classList.remove('rg-fade');
        idx++;
      }, 320);
    }, 3000);
    row.dataset.interval = interval;
  }

  function removeTyping() {
    const t = document.getElementById('rg-typing-row');
    if (t) { clearInterval(parseInt(t.dataset.interval)); t.remove(); }
  }

  function scroll() { messages.scrollTop = messages.scrollHeight; }

  async function triggerSend(text) {
    input.value = text;
    await sendMessage();
  }

  async function sendMessage() {
    const text = input.value.trim();
    if (!text) return;
    input.value = '';
    sendBtn.disabled = true;
    document.getElementById('rg-welcome')?.remove();
    if (!messages.querySelector('.rg-date-chip')) addDateChip();
    addUserMessage(text);
    showTyping();
    try {
      const res = await fetch(N8N_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ message: text, sessionId: SESSION_ID })
      });
      const data = await res.json();
      removeTyping();
      const reply = data.text_response || data.textresponse || data.output || 'Let me help you find the perfect gift!';
      const products = Array.isArray(data.products) ? data.products : [];
      addBotMessage(reply, products);
    } catch (e) {
      removeTyping();
      addBotMessage('Something went wrong. Please try again in a moment!', []);
    } finally {
      sendBtn.disabled = false;
      input.focus();
    }
  }
})();
